import { render, staticRenderFns } from "./theme-picker.vue?vue&type=template&id=0012f3c3&"
import script from "./theme-picker.vue?vue&type=script&lang=js&"
export * from "./theme-picker.vue?vue&type=script&lang=js&"
import style0 from "./theme-picker.vue?vue&type=style&index=0&id=0012f3c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports